import { api, attachmentsAPI } from '@viilutalous/common';

export const rowAttachmentsAPI = {
  getAll: (tenantId, params) =>
    api.get(`/${tenantId}/attachments`, { params: { ...params, attachment_type: 'expense_row' } }),
  getByRow: (tenantId, rowId) =>
    api.get(`/${tenantId}/attachments`, { params: { link_id: rowId, attachment_type: 'expense_row' } }),
  upload: (tenantId, rowId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('link_id', rowId);
    formData.append('attachment_type', 'expense_row');
    return attachmentsAPI.upload(tenantId, formData);
  },
  delete: (tenantId, attachmentId) => attachmentsAPI.delete(tenantId, attachmentId),
  getFile: (tenantId, attachmentId) => attachmentsAPI.getFile(tenantId, attachmentId),
};

export const expensesAPI = {
  getAll: (tenantId, params) => api.get(`/${tenantId}/expenses`, { params }),
  getOne: (tenantId, id) => api.get(`/${tenantId}/expenses/${id}`),
  create: (tenantId, data) => api.post(`/${tenantId}/expenses`, data),
  update: (tenantId, id, data) => api.put(`/${tenantId}/expenses/${id}`, data),
  delete: (tenantId, id) => api.delete(`/${tenantId}/expenses/${id}`),
  submit: (tenantId, id) => api.post(`/${tenantId}/expenses/${id}/submit`),
  approve: (tenantId, id) => api.post(`/${tenantId}/expenses/${id}/approve`),
  refuse: (tenantId, id) => api.post(`/${tenantId}/expenses/${id}/refuse`),
  post: (tenantId, id) => api.post(`/${tenantId}/expenses/${id}/post`),
  reset: (tenantId, id) => api.post(`/${tenantId}/expenses/${id}/reset`),
  addRow: (tenantId, id, data) => api.post(`/${tenantId}/expenses/${id}/rows`, data),
  updateRow: (tenantId, id, rowId, data) => api.put(`/${tenantId}/expenses/${id}/rows/${rowId}`, data),
  deleteRow: (tenantId, id, rowId) => api.delete(`/${tenantId}/expenses/${id}/rows/${rowId}`),
};

export const categoriesAPI = {
  getAll: (tenantId) => api.get(`/${tenantId}/expense-categories`),
  getOne: (tenantId, id) => api.get(`/${tenantId}/expense-categories/${id}`),
  create: (tenantId, data) => api.post(`/${tenantId}/expense-categories`, data),
  update: (tenantId, id, data) => api.put(`/${tenantId}/expense-categories/${id}`, data),
  delete: (tenantId, id) => api.delete(`/${tenantId}/expense-categories/${id}`),
};
